import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastType } from '../../components/core/labels/toast.component';

@Injectable({
  providedIn: 'root',
})
export class Snackbar {
  private messageService = inject(MessageService);


  show(
    label: string,
    type: ToastType = 'Info',
    icon: string = null,
    lifeMs = 5000,
  ) {
    this.messageService.add({
      key: 'snackbar',
      sticky: false,
      severity: 'custom',
      styleClass: 'tw-drop-shadow-2xl',
      life: lifeMs,
      closable: false,
      data: {
        label,
        type,
        icon,
      },
    });
  }
}
